import React, { useState, useEffect } from 'react';

//Tabla generica, requiere un array (heads) de keys en formato string, y el array data que es un arrray de jsons donde cada elemento debe contener todas las keys de head para que funcione bien
const TableHeadsData = (p) => {
  const dataClean = p.data;
  const heads = p.heads;
  const className = p.classN ?? 'table-container-s col-lg-12';
  const styleName = p.styleName ?? { width: '100% !important', height: '40vh' };
  useEffect(() => {
  }, [p.data, p.heads]);

  //Verificaciones antes de desplegar para evitar errores en tiempo de ejecución
  if (!Array.isArray(dataClean) || !Array.isArray(heads)) return (<p className='text-center'>Los datos o encabezados no son arrays</p>);
  for (let i = 0; i < heads.length; i++) {
    if (typeof heads[i] !== 'string') return (<p className='text-center'>Uno o más encabezados no son cadenas de texto</p>);
  }
  if (dataClean.length == 0) return (<p className='text-center'>Sin datos para mostrar</p>);
  for (let i = 0; i < dataClean.length; i++) {
    let element = dataClean[i];
    if (typeof element !== 'object') return (<p className='text-center'>Uno o más datos del array de datos no es válido</p>);
  }

  return (
    <div className={className} style={styleName}>
      <table className="table table-responsive table-sm table-bordered table-striped table-hover text-s" >
        <thead>
          <tr>
            {
              heads.map((nameT, i) => {
                return (
                  <th className="text-center p-2 nowrap" key={"head names " + i}>{nameT}</th>
                )
              })
            }
          </tr>
        </thead>
        <tbody>
          {
            dataClean.map((dataC, j) => {
              return (
                <tr key={" rpw1 " + j} onClick={() => { if (p.action) p.action(dataC, j) }}>
                  {
                    heads.map((nameTb, k) => {
                      return (
                        <td className="text-center p-2 nowrap text-s nowrap" key={" values " + j + " name" + k}>{dataC[nameTb]}</td>
                      )
                    })
                  }
                </tr>
              )
            })
          }
        </tbody>

      </table>

    </div>
  )
}

export default TableHeadsData;